import React from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TimeLineFilters from '@auteco/components/reports/finder/TimeLineFilters/TimeLineFilters'
import UserInfoByDocument from '@auteco/components/reports/finder/UserInfoByDocument/UserInfoByDocument'
import UserInfoByPlaca from '@auteco/components/reports/finder/UserInfoByPlaca/UserInfoByPlaca'
import SummaryInfoCards from '@auteco/components/reports/finder/SummaryInfoCards/SummaryInfoCards'
import Finder from '../../../components/reports/finder/finder/Finder'
import Mobilitimetro from '../../../components/reports/finder/mobilitimetro/Mobilitimetro'

const SearchForPlacas = (props) => {
  const { users, points, usersPlaca, handlerSubmit } = props
  console.log('points seach for placas', points)
  return (
    <>
      <CardTitle title="Buscador por placa o documento" />
      <Finder handlerSubmit={handlerSubmit} />

      {points.length >= 1 ? (
        <Mobilitimetro points={points} />
      ) : null}
      {users.length > 0 || users.datos ? (
        <UserInfoByDocument users={users} />
      ) : null}
      {users.length > 0 || users.datos ? (
        <SummaryInfoCards users={users} />
      ) : null}
      {usersPlaca.length > 0 ? (
        <UserInfoByPlaca users={usersPlaca} key={usersPlaca} />
      ) : null}

      {users?.length > 0 || users.datos ? (
        <TimeLineFilters users={users} key={users} />
      ) : null}
    </>
  )
}
export default SearchForPlacas
